export var IdentityCardAlias = "Alias";
export var IdentityCardContact = "Contact";
export var IdentityCardContactInfo = "Contact information";
export var IdentityCardDepartment = "Department";
export var IdentityCardDistributionList = "Distribution list";
export var IdentityCardEmail = "Email";
export var IdentityCardHeaderButtonLabel = "Go back";
export var IdentityCardLoadingText = "Loading identities...";
export var IdentityCardLocation = "Location";
export var IdentityCardMembers = "{0} members";
export var IdentityCardMembersCount = "Members ({0})";
export var IdentityCardNoResultsText = "No identities found";
export var IdentityCardOrganization = "Organization";
export var IdentityCardPhoneNumber = "Phone number";
export var IdentityCardPlaceholderText = "Search users and groups";
export var IdentityCardProfileCardAriaLabel = "Contact card";
export var IdentityCardReportingTo = "Reporting to {0} ({1})";
export var IdentityCardReportsTo = "Reports to";
export var IdentityCardResultsFoundText = "Showing {0} results";
export var IdentityCardStartChat = "Start chat";
export var IdentityCardTitle = "Title";
export var IdentityCardUnknownUser = "Unknown user";
export var Loading = "Loading...";
